import React from "react";
import "../css/AmbientBackground.css";
import ThemeToggle from "./ThemeToggle";

/**
 * Example usage of the new form and stacked-card styles.
 * Not required for production — shows how the pieces fit together.
 */

export default function ExampleSection() {
  return (
    <div className="av-page">
      <div className="av-glow-field" aria-hidden="true">
        <div className="av-glow av-glow--amber" />
        <div className="av-glow av-glow--teal" />
        <div className="av-grain" />
      </div>

      <header className="av-glass" style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span>Atelier Verre</span>
        <ThemeToggle />
      </header>

      {/* ---- form wrapped in <div><form></div> ---- */}
      <section className="av-layer" style={{ maxWidth: 480, margin: "60px auto" }}>
        <div className="av-form-wrap">
          <form onSubmit={(e) => e.preventDefault()}>
            <label>
              Name
              <input type="text" placeholder="Your name" />
            </label>
            <div className="av-form-row">
              <label>
                Email
                <input type="email" placeholder="you@example.com" />
              </label>
              <label>
                Phone
                <input type="tel" placeholder="Optional" />
              </label>
            </div>
            <label>
              Message
              <textarea placeholder="Tell us about the project" />
            </label>
            <button className="av-form-submit" type="submit">
              Send inquiry
            </button>
            <p className="av-form-note">We reply within two business days.</p>
          </form>
        </div>
      </section>

      {/* ---- stacked cards ---- */}
      <section className="av-layer" style={{ maxWidth: 420, margin: "60px auto 120px" }}>
        <div className="av-card-stack">
          <div style={{ padding: 24 }}>
            <h3>Studio visit</h3>
            <p>By appointment, Tuesday–Saturday.</p>
          </div>
          <div style={{ padding: 24 }}>
            <h3>Custom commissions</h3>
            <p>Architectural panels, lighting, vessels.</p>
          </div>
          <div style={{ padding: 24 }}>
            <h3>Wholesale</h3>
            <p>Galleries and design studios, ask for our catalog.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
